<div class="container-fluid importa-talao-itau">
  <h3 class="mb-0">Importa talão Itau</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <div class="all-center">
          <button type="button" mat-raised-button color="primary" [disabled]="isLoading"
            (click)="fileInput.click()">Selecionar
            arquivo</button>
          <input hidden (change)="onFileChange($event)" #fileInput type="file" id="file">
        </div>
        <div class="all-center">
          Total de {{itensOk.length}} para ser processados
        </div>
        <div class="all-center">
          <button mat-flat-button color="primary" [disabled]="itensOk.length == 0 || isLoading"
            (click)="enviarProcessados()">Processar</button>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content *ngIf="respostaImportaItau">
      <div class="all-center">
        Total de {{respostaImportaItau.listaOk.length}} foram processados
      </div>
      <div *ngIf="respostaImportaItau.listaError">
        <div class="all-center">
          Total de {{respostaImportaItau.listaError.length}} não foram processados
        </div>
        <div class="all-center">
          <button mat-flat-button color="primary" (click)="exportItensErro()">Baixar
            arquivos com erro</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>